import Event from './Event';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

Event.schema = schema;
Event.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default Event;
